const fluorsparData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133795/assets/data-reports/price-assessments/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_2f682912-2ed8-4ac4-bf5f-61296cfbd535_lcjrrz.png',
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureFluorsparFilePdfID',
    file_name: 'Fluorspar Forecast Brochure.pdf',
    category: 'public-documents',
  },
  banner: {
    title:
      'Benchmark’s Fluorspar Market Outlook service provides a detailed assessment of supply, demand and prices and is updated on a quarterly basis:',
    descriptions: [
      {
        items: [
          '<strong>Asset-level insights:</strong> Supply analysis broken down by asset with results presented to show market dynamics.',
          '<strong>Plant by Plant:</strong> Granular review of processed materials by operation outside of China, including material flows to processing facilities within China.',
          '<strong>Demand Analysis:</strong> fluorspar demand from lithium-ion batteries by category and regional end-use sector, including assessment of short-term market movements. Volumes are calculated for <strong>acidspar, hydrofluoric acid </strong> (HF acid), <strong>PVDF</strong> and <strong>electrolyte</strong> salts.',
          '<strong>Prices:</strong> market prices for fluorspar, acidspar (CaF >97%) and HF acid on a US$ per tonne FOB China basis.',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_500,f_auto/v1705418038/assets/forecasts/fluorspar/benchmarkminerals_Phosphoric_acid_tones_of_yellow_and_white_in__4b8e566b-eed9-4f73-9fa5-dc6b96c68b07_2_3_cv9t7u.png',
        alt: 'Synthetic Graphite Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_300,f_auto/v1705418038/assets/forecasts/fluorspar/benchmarkminerals_Phosphoric_acid_tones_of_yellow_and_white_in__4b8e566b-eed9-4f73-9fa5-dc6b96c68b07_2_4_ajub4l.png',
        alt: 'Synthetic Graphite Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_300,f_auto/v1705418037/assets/forecasts/fluorspar/benchmarkminerals_LFP_Battery_Cell_tones_of_yellow_and_white_in_c1499e8d-1e1e-4477-906e-2cfceac1b16d_2_2_j8vfea.png',
        alt: 'Synthetic Graphite Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_700,f_auto/v1705418039/assets/forecasts/fluorspar/benchmarkminerals_Data_on_a_10_large_screens_charts_graphs_visu_2d5af8f8-bac6-4270-afce-27aae5a96bfd_1_1_ql87rb.png',
      title:
        'Benchmark’s Fluorspar Market Outlook service features detailed data and analysis out to 2030:',
      descriptions: [
        {
          items: [
            '<strong>Market outlook:</strong> compare <strong>fluorspar</strong> market outlooks by raw material and processed product for a thorough view of the market.',
            '<strong>Demand drivers:</strong> end-use demand broken down by specific end-use out to 2030. The <strong>Fluorspar Market Outlook</strong> focusses on fluorspar’s use in the global lithium-ion battery supply chain.',
            '<strong>Regional perspectives:</strong> examine fluorspar mining, processed hydrofluoric acid, PVDF and electrolyte supply dynamics on a regional and asset basis.',
            '<strong>Developments:</strong> Track <strong>key investments</strong>, partnerships, and announcements over each quarter',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_500,f_auto/v1705418039/assets/forecasts/fluorspar/benchmarkminerals_Data_on_a_10_large_screens_45_degree_angle_ch_50187cc6-1672-4dc8-aacb-5c25afdd67cd_2_1_ba2opt.png',
      title:
        'You will receive full, unrestricted access to the data presented in Benchmark’s Fluorspar Market Outlook service:',
      descriptions: [
        {
          items: [
            '<strong>Online accessible</strong> downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in excel and pdf format.',
          ],
        },
      ],
      showButtonContact: true,
      textButtonContact: 'Contact Us',
    },
  },
}
export default fluorsparData
